import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "popup-dialog flex transition-all max-w-2xl min-h-full items-center mx-auto px-4 sm:px-6 mt-8 sm:mt-0" }
const _hoisted_2 = { class: "w-full bg-white/95 backdrop-blur-lg rounded-2xl overflow-hidden relative shadow-2xl border border-white/20 mt-8 sm:mt-0" }
const _hoisted_3 = { class: "bg-gradient-to-br from-pink-400 via-purple-400 to-blue-400 p-4 relative overflow-hidden" }
const _hoisted_4 = { class: "relative flex items-center justify-between" }
const _hoisted_5 = { class: "flex items-center space-x-3" }
const _hoisted_6 = { class: "text-lg font-bold text-gray-900" }
const _hoisted_7 = { class: "text-gray-700 text-xs" }
const _hoisted_8 = { class: "bg-white p-4 overflow-y-auto max-h-[70vh]" }
const _hoisted_9 = { class: "space-y-3" }
const _hoisted_10 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_11 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_12 = ["placeholder"]
const _hoisted_13 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_14 = ["placeholder"]
const _hoisted_15 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_16 = { class: "relative" }
const _hoisted_17 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_18 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_19 = ["placeholder"]
const _hoisted_20 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_21 = ["placeholder"]
const _hoisted_22 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_23 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_24 = {
  value: "",
  disabled: ""
}
const _hoisted_25 = { value: "המלצה" }
const _hoisted_26 = { value: "אתר אינטרנט" }
const _hoisted_27 = { value: "אחר" }
const _hoisted_28 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_29 = {
  value: "",
  disabled: ""
}
const _hoisted_30 = { value: "New" }
const _hoisted_31 = { value: "Contacted" }
const _hoisted_32 = { value: "Qualified" }
const _hoisted_33 = { value: "Won" }
const _hoisted_34 = { value: "Lost" }
const _hoisted_35 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_36 = ["placeholder"]
const _hoisted_37 = { class: "flex justify-between gap-3 pt-4" }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = {
  key: 0,
  class: "fixed bottom-6 right-6 left-6 md:left-auto md:max-w-md z-50"
}
const _hoisted_42 = { class: "flex items-center justify-between" }
const _hoisted_43 = { class: "flex items-center" }
const _hoisted_44 = {
  key: 0,
  class: "material-symbols-outlined !text-[22px]"
}
const _hoisted_45 = {
  key: 1,
  class: "material-symbols-outlined !text-[22px]"
}
const _hoisted_46 = {
  key: 2,
  class: "material-symbols-outlined !text-[22px]"
}
const _hoisted_47 = { class: "font-semibold text-gray-800" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass([
      'add-new-popup z-[999] fixed transition-all inset-0 overflow-x-hidden overflow-y-auto py-4 sm:py-6 bg-black/60 backdrop-blur-md',
      { active: _ctx.stateStoreInstance.active },
    ])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "absolute inset-0 bg-gradient-to-br from-white/10 to-transparent" }, null, -1)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "w-10 h-10 bg-white/30 rounded-xl flex items-center justify-center backdrop-blur-sm" }, [
                  _createElementVNode("i", { class: "material-symbols-outlined text-gray-900 !text-[20px]" }, "person_add")
                ], -1)),
                _createElementVNode("div", null, [
                  _createElementVNode("h5", _hoisted_6, _toDisplayString(_ctx.directT('crm.leads.addNewLeadPopup.newLead')), 1),
                  _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.directT('crm.leads.addNewLeadPopup.addNewLeadToSystem')), 1)
                ])
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "w-8 h-8 rounded-lg bg-white/20 hover:bg-white/30 text-white transition-all duration-200 flex items-center justify-center",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.activeBtn && _ctx.stateStoreInstance.activeBtn(...args)))
              }, _cache[13] || (_cache[13] = [
                _createElementVNode("i", { class: "material-symbols-outlined !text-[16px]" }, "close", -1)
              ]))
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("form", {
              onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveLead && _ctx.saveLead(...args)), ["prevent"])),
              class: "space-y-4"
            }, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", null, [
                    _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.directT('crm.leads.addNewLeadPopup.firstName')), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newLead.name) = $event)),
                      required: "",
                      placeholder: _ctx.directT('crm.leads.addNewLeadPopup.firstName'),
                      class: "w-full h-9 rounded-lg bg-gray-50 border border-gray-200 text-gray-900 px-3 text-sm placeholder-gray-400 focus:border-purple-400 focus:ring-1 focus:ring-purple-400 focus:bg-white outline-none transition-all"
                    }, null, 8, _hoisted_12), [
                      [_vModelText, _ctx.newLead.name]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.directT('crm.leads.addNewLeadPopup.lastName')), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newLead.lastName) = $event)),
                      placeholder: _ctx.directT('crm.leads.addNewLeadPopup.lastName'),
                      class: "w-full h-9 rounded-lg bg-gray-50 border border-gray-200 text-gray-900 px-3 text-sm placeholder-gray-400 focus:border-purple-400 focus:ring-1 focus:ring-purple-400 focus:bg-white outline-none transition-all"
                    }, null, 8, _hoisted_14), [
                      [_vModelText, _ctx.newLead.lastName]
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.directT('crm.leads.addNewLeadPopup.emailAddress')), 1),
                  _createElementVNode("div", _hoisted_16, [
                    _cache[15] || (_cache[15] = _createElementVNode("i", { class: "material-symbols-outlined absolute left-3 top-2 text-gray-400 !text-[16px]" }, "email", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "email",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newLead.email) = $event)),
                      required: "",
                      placeholder: "example@domain.com",
                      class: "w-full h-9 rounded-lg bg-gray-50 border border-gray-200 text-gray-900 px-3 pl-8 text-sm placeholder-gray-400 focus:border-purple-400 focus:ring-1 focus:ring-purple-400 focus:bg-white outline-none transition-all"
                    }, null, 512), [
                      [_vModelText, _ctx.newLead.email]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", null, [
                    _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.directT('crm.leads.addNewLeadPopup.phone')), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "tel",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newLead.phone) = $event)),
                      placeholder: _ctx.directT('crm.leads.addNewLeadPopup.phonePlaceholder'),
                      class: "w-full h-9 rounded-lg bg-gray-50 border border-gray-200 text-gray-900 px-3 text-sm placeholder-gray-400 focus:border-purple-400 focus:ring-1 focus:ring-purple-400 focus:bg-white outline-none transition-all"
                    }, null, 8, _hoisted_19), [
                      [_vModelText, _ctx.newLead.phone]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.directT('crm.leads.addNewLeadPopup.company')), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newLead.company) = $event)),
                      placeholder: _ctx.directT('crm.leads.addNewLeadPopup.companyName'),
                      class: "w-full h-9 rounded-lg bg-gray-50 border border-gray-200 text-gray-900 px-3 text-sm placeholder-gray-400 focus:border-purple-400 focus:ring-1 focus:ring-purple-400 focus:bg-white outline-none transition-all"
                    }, null, 8, _hoisted_21), [
                      [_vModelText, _ctx.newLead.company]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", null, [
                    _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.directT('crm.leads.addNewLeadPopup.leadSource')), 1),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.newLead.source) = $event)),
                      required: "",
                      class: "w-full h-9 rounded-lg bg-gray-50 border border-gray-200 text-gray-900 px-3 text-sm focus:border-purple-400 focus:ring-1 focus:ring-purple-400 focus:bg-white outline-none transition-all"
                    }, [
                      _createElementVNode("option", _hoisted_24, _toDisplayString(_ctx.directT('crm.leads.addNewLeadPopup.selectSource')), 1),
                      _cache[16] || (_cache[16] = _createElementVNode("option", { value: "Google" }, "Google", -1)),
                      _cache[17] || (_cache[17] = _createElementVNode("option", { value: "Facebook" }, "Facebook", -1)),
                      _cache[18] || (_cache[18] = _createElementVNode("option", { value: "LinkedIn" }, "LinkedIn", -1)),
                      _createElementVNode("option", _hoisted_25, _toDisplayString(_ctx.directT('crm.leads.addNewLeadPopup.referral')), 1),
                      _createElementVNode("option", _hoisted_26, _toDisplayString(_ctx.directT('crm.leads.addNewLeadPopup.website')), 1),
                      _createElementVNode("option", _hoisted_27, _toDisplayString(_ctx.directT('crm.leads.addNewLeadPopup.other')), 1)
                    ], 512), [
                      [_vModelSelect, _ctx.newLead.source]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.directT('crm.leads.addNewLeadPopup.status')), 1),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newLead.status) = $event)),
                      required: "",
                      class: "w-full h-9 rounded-lg bg-gray-50 border border-gray-200 text-gray-900 px-3 text-sm focus:border-purple-400 focus:ring-1 focus:ring-purple-400 focus:bg-white outline-none transition-all"
                    }, [
                      _createElementVNode("option", _hoisted_29, _toDisplayString(_ctx.directT('crm.leads.addNewLeadPopup.selectStatus')), 1),
                      _createElementVNode("option", _hoisted_30, _toDisplayString(_ctx.directT('crm.leads.addNewLeadPopup.statusNew')), 1),
                      _createElementVNode("option", _hoisted_31, _toDisplayString(_ctx.directT('crm.leads.addNewLeadPopup.statusContacted')), 1),
                      _createElementVNode("option", _hoisted_32, _toDisplayString(_ctx.directT('crm.leads.addNewLeadPopup.statusQualified')), 1),
                      _createElementVNode("option", _hoisted_33, _toDisplayString(_ctx.directT('crm.leads.addNewLeadPopup.statusWon')), 1),
                      _createElementVNode("option", _hoisted_34, _toDisplayString(_ctx.directT('crm.leads.addNewLeadPopup.statusLost')), 1)
                    ], 512), [
                      [_vModelSelect, _ctx.newLead.status]
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.directT('crm.leads.addNewLeadPopup.notes')), 1),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newLead.notes) = $event)),
                    rows: "2",
                    placeholder: _ctx.directT('crm.leads.addNewLeadPopup.additionalNotes'),
                    class: "w-full rounded-lg bg-gray-50 border border-gray-200 text-gray-900 px-3 py-2 text-sm placeholder-gray-400 focus:border-purple-400 focus:ring-1 focus:ring-purple-400 focus:bg-white outline-none transition-all resize-none"
                  }, null, 8, _hoisted_36), [
                    [_vModelText, _ctx.newLead.notes]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("button", {
                  type: "button",
                  class: "py-2 px-4 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium rounded-lg transition-all duration-200 text-sm border border-gray-200",
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.activeBtn && _ctx.stateStoreInstance.activeBtn(...args)))
                }, _toDisplayString(_ctx.directT('crm.leads.addNewLeadPopup.cancel')), 1),
                _createElementVNode("button", {
                  type: "submit",
                  disabled: _ctx.loading,
                  class: "py-2 px-6 bg-purple-600 hover:bg-purple-700 text-white font-semibold rounded-lg transition-all duration-200 disabled:opacity-70 disabled:cursor-not-allowed text-sm shadow-sm"
                }, [
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(_ctx.directT('crm.leads.addNewLeadPopup.saving')), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(_ctx.directT('crm.leads.addNewLeadPopup.save')), 1))
                ], 8, _hoisted_38)
              ])
            ], 32)
          ])
        ])
      ])
    ], 2),
    (_ctx.toastMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
          _createElementVNode("div", {
            class: _normalizeClass(["p-4 rounded-2xl shadow-xl transform transition-all duration-300 border-2 backdrop-blur-lg animate-bounce", { 
           'bg-white/95 border-green-400 text-green-700': _ctx.toastType === 'success', 
           'bg-white/95 border-red-400 text-red-700': _ctx.toastType === 'error', 
           'bg-white/95 border-blue-400 text-blue-700': _ctx.toastType === 'info' 
         }])
          }, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", {
                  class: _normalizeClass(["w-10 h-10 rounded-xl flex items-center justify-center mr-3", { 
                 'bg-green-50 border border-green-200': _ctx.toastType === 'success',
                 'bg-red-50 border border-red-200': _ctx.toastType === 'error',
                 'bg-blue-50 border border-blue-200': _ctx.toastType === 'info'
               }])
                }, [
                  (_ctx.toastType === 'success')
                    ? (_openBlock(), _createElementBlock("i", _hoisted_44, "check_circle"))
                    : (_ctx.toastType === 'error')
                      ? (_openBlock(), _createElementBlock("i", _hoisted_45, "error"))
                      : (_openBlock(), _createElementBlock("i", _hoisted_46, "info"))
                ], 2),
                _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.toastMessage), 1)
              ]),
              _createElementVNode("button", {
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.closeToast && _ctx.closeToast(...args))),
                class: "ml-4 p-2 rounded-xl hover:bg-gray-100 transition-all duration-200"
              }, _cache[19] || (_cache[19] = [
                _createElementVNode("i", { class: "material-symbols-outlined !text-[20px] text-gray-500" }, "close", -1)
              ]))
            ])
          ], 2)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}